import React from "react";

export const DisplayProgress = ({message}: { message: string }): React.ReactElement | null  => {
    if (typeof message !== "string") {
        return null;
    }

    return (
        <div className="horizontal-loading horizontal-loading-sm p-0 mt-5">
            <div className="loading-bar" role="progressbar"></div>
            {message &&
                <span className="loading-bar-label ms-4">{message}</span>
            }
        </div>
    )
};

export default DisplayProgress;